import { useCallback } from 'react'

import { useForm } from '@tanstack/react-form'
import { getRouteApi } from '@tanstack/react-router'
import { CompanySelect, FF, Select } from 'ui/components'
import { FilterPanel } from 'ui/components/Table'
import { SarList, SarListPayload } from '~bank-bsa-reporting/types'

import * as SC from './styles'

const routeApi = getRouteApi('/_app/bsa/sars/')

export const FilterForm = ({ data }: { data: SarList }) => {
  const searchParams = routeApi.useSearch()
  const navigate = routeApi.useNavigate()
  const isChanged = routeApi.useLoaderDeps({ select: (s) => s.isChanged })

  const { statusOptions } = data

  const formApi = useForm({
    defaultValues: {
      companyId: data?.form?.onlyMyCompanies ? 'my' : data?.form?.companyId,
      status: searchParams.status || null
    } as Pick<SarListPayload, 'companyId' | 'status'>
  })

  const updateSearchParams = (newValue: SarListPayload) => {
    navigate({
      to: '.',
      search: (prev) => ({ ...prev, ...newValue, page: 1 }),
      resetScroll: false
    })
  }

  const clear = useCallback(() => {
    formApi.reset()
    navigate({ search: undefined })
  }, [formApi, navigate])

  return (
    <FilterPanel isDirty={isChanged} onReset={clear}>
      <SC.FormWrapper>
        <SC.Row>
          <formApi.Field
            name="companyId"
            validators={{
              onChange: ({ value }) => {
                if (typeof value === 'string' && value === 'my') {
                  updateSearchParams({ onlyMyCompanies: true, companyId: undefined })
                  return undefined
                } else {
                  updateSearchParams({ onlyMyCompanies: false, companyId: value })
                  return undefined
                }
              }
            }}
            children={(field) => (
              <FF
                field={field}
                label="Company"
                input={(inputProps) => (
                  <CompanySelect
                    {...inputProps}
                    hideMyCompaniesFilter={false}
                    defaultOption={{ label: 'All', value: null }}
                  />
                )}
              />
            )}
          />
          <formApi.Field
            name="status"
            validators={{
              onChange: ({ value }) => {
                updateSearchParams({ status: value })
                return undefined
              }
            }}
            children={(field) => (
              <FF
                field={field}
                label="Status"
                input={(inputProps) => <Select {...inputProps} data={statusOptions} />}
              />
            )}
          />
        </SC.Row>
      </SC.FormWrapper>
    </FilterPanel>
  )
}
